// Libs
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Constants
import {
  ROUTE_404,
  ROUTE_STANDALONE_BARCODE,
  ROUTE_STANDALONE_CART,
  ROUTE_STANDALONE_CART_ADD,
} from '@/common/constants';
// Contexts
import { useAuth } from '@/common/contexts/AuthContext';
// Router
import PrivateRoute from '@/common/router/PrivateRoute';

// Pages
import BarCodePrint from './BarCodePrint/BarCodePrint';
import Cart from './Cart/Cart.container';
import CartAdd from './CartAdd/CartAdd';

const Standalone = () => {
  const { user } = useAuth();

  return (
    <>
      <Switch>
        {user?.functionality_accesses?.carts && (
          <Route path={ROUTE_STANDALONE_CART} exact>
            <Cart />
          </Route>
        )}
        {user?.functionality_accesses?.carts && (
          <Route path={`${ROUTE_STANDALONE_CART_ADD}/:sku`} exact>
            <CartAdd />
          </Route>
        )}
        {user?.functionality_accesses?.wishlists &&
          user?.functionality_accesses?.wishlists_print && (
            <Route path={`${ROUTE_STANDALONE_BARCODE}/:id/:size`} exact>
              <BarCodePrint />
            </Route>
          )}
        <PrivateRoute>
          <Redirect to={ROUTE_404} />
        </PrivateRoute>
      </Switch>
    </>
  );
};

export default Standalone;
